import { Redirect } from '@reach/router';
import { useEffect, type FC } from 'react';

import { Observer } from '@xing-com/crate-communication-in-view';
import { discoNetworkUpdatesRoute } from '@xing-com/crate-discovery-routes';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { InsightSection } from '@xing-com/crate-insights-sections';
import { useInsightsTracking } from '@xing-com/crate-insights-tracking';
import { GridContainer, GridItem } from '@xing-com/grid';

import {
  MetaData,
  SalaryBanner,
  StyledSection,
  TeaserSignUp,
} from './components';

export const Entry: FC = () => {
  const { isLoggedOut } = useLoginState();
  const { trackWithNWT } = useInsightsTracking();

  useEffect(() => {
    isLoggedOut && trackWithNWT({ event: 'viewed_screen' });
  }, [isLoggedOut, trackWithNWT]);

  return !isLoggedOut ? (
    <Redirect to={`/${discoNetworkUpdatesRoute}`} />
  ) : (
    <>
      <MetaData />
      <Observer page="insights-logged-out">
        <GridContainer variant="expanded" data-qa="insights-entry-logged-out">
          <StyledSection $hero>
            <InsightSection name="hero" />
          </StyledSection>

          <StyledSection>
            <InsightSection name="salary" />
          </StyledSection>

          <StyledSection>
            <SalaryBanner />
          </StyledSection>

          <StyledSection>
            <InsightSection name="jobs" />
          </StyledSection>

          <GridItem>
            <TeaserSignUp />
          </GridItem>
        </GridContainer>
      </Observer>
    </>
  );
};
